import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-brand-gray py-8 px-6" data-id="element-1">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-2">
          <div className="flex items-center gap-6" data-id="element-3">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white text-sm font-medium transition-colors underline underline-offset-2" data-id="element-4">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-5">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white text-sm font-medium transition-colors underline underline-offset-2" data-id="element-6">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-500 text-xs" data-id="element-7">
            © {new Date().getFullYear()} Lonchera Master USA. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={closeModal} data-id="element-8">
          <div className="bg-white rounded-3xl shadow-xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-9">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-10">
              <h2 className="text-2xl font-bold text-brand-gray font-heading" data-id="element-11">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={closeModal} className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-12">
                <X className="w-5 h-5 text-gray-500" data-id="element-13" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto text-gray-600 leading-relaxed space-y-4 text-sm" data-id="element-14">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-15" /> : <TermsContent data-id="element-16" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-400 italic" data-id="element-17">
        Última actualización: marzo 2026
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-18">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-19">
        Al adquirir Lonchera Master USA, recopilamos únicamente la información
        necesaria para procesar tu compra: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos información de tarjetas de
        crédito directamente; todos los pagos son procesados por plataformas de
        pago seguras de terceros.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-20">
        2. Uso de la Información
      </h3>
      <p data-id="element-21">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-22">
        <li data-id="element-23">Entregar el producto digital adquirido.</li>
        <li data-id="element-24">Enviar confirmación de compra y recibos.</li>
        <li data-id="element-25">Comunicar actualizaciones importantes sobre el producto.</li>
      </ul>
      <p data-id="element-26">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros con fines de marketing.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-27">
        3. Protección de Datos
      </h3>
      <p data-id="element-28">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal contra acceso no autorizado, alteración
        o destrucción.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-29">4. Cookies</h3>
      <p data-id="element-30">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies en cualquier momento.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-31">
        5. Tus Derechos
      </h3>
      <p data-id="element-32">
        Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
        personales en cualquier momento.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-33">
        6. Cambios a esta Política
      </h3>
      <p data-id="element-34">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-400 italic" data-id="element-35">
        Última actualización: marzo 2026
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-36">
        1. Producto Digital
      </h3>
      <p data-id="element-37">
        Lonchera Master USA es un producto digital (guía descargable). Al
        completar tu compra, recibirás acceso inmediato al contenido. No se
        realizan envíos físicos.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-38">
        2. Uso Permitido
      </h3>
      <p data-id="element-39">
        La guía es para uso personal y familiar únicamente. Queda estrictamente
        prohibido:
      </p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-40">
        <li data-id="element-41">
          Reproducir, distribuir o revender el contenido total o parcialmente.
        </li>
        <li data-id="element-42">Compartir el acceso o los archivos con terceros.</li>
        <li data-id="element-43">
          Utilizar el contenido con fines comerciales sin autorización escrita.
        </li>
      </ul>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-44">
        3. Propiedad Intelectual
      </h3>
      <p data-id="element-45">
        Todo el contenido de Lonchera Master USA, incluyendo textos, diseños,
        imágenes y estructura, está protegido por derechos de autor. La compra
        otorga una licencia de uso personal, no la transferencia de propiedad
        intelectual.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-46">
        4. Política de Reembolso
      </h3>
      <p data-id="element-47">
        Debido a la naturaleza digital del producto y al acceso inmediato tras
        la compra, no se ofrecen reembolsos una vez entregado el contenido. Si
        experimentas problemas técnicos para acceder al producto, te ayudaremos
        a resolverlos.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-48">
        5. Descargo de Responsabilidad
      </h3>
      <p data-id="element-49">
        La información proporcionada en esta guía es de carácter informativo y
        educativo. No sustituye el consejo médico o nutricional profesional. Los
        resultados pueden variar según las circunstancias individuales de cada
        familia.
      </p>

      <h3 className="text-lg font-bold text-brand-gray mt-4" data-id="element-50">
        6. Modificaciones
      </h3>
      <p data-id="element-51">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. El uso continuado del producto después de cualquier cambio
        constituye la aceptación de los nuevos términos.
      </p>
    </>;
}